












































import { Component, Mixins, PropSync } from "vue-property-decorator";
import RulesMixin from "@/mixins/RulesMixin";
import { State } from "vuex-class";
import { ReferenceItem } from "@/services/types";

@Component
export default class ContactFormAddressInfo extends Mixins(RulesMixin) {
  @State("countries", { namespace: "selectOptions" })
  countries!: ReferenceItem[];

  @PropSync("address", { type: String }) addressLocal!: string;
  @PropSync("postcode", { type: String }) postcodeLocal!: string;
  @PropSync("city", { type: String }) cityLocal!: string;
  @PropSync("countryId", { type: Number }) countryIdLocal!: number | null;
}
